import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';
import { Badge, Star } from 'lucide-react';
import { isProUser } from '../../utils/proUtils';

interface UserRoleBadgeProps {
  className?: string;
}

export const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ className = '' }) => {
  const { user } = useAuth();
  const { isStudent, isTeacher, isAdmin } = usePermissions();

  if (!user) return null;

  const isPro = isProUser(user);

  const getRoleInfo = () => {
    if (isAdmin) {
      return {
        text: 'Quản trị viên',
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: '👑',
      };
    }
    
    if (isTeacher) {
      // Check if teacher is approved
      const isApproved = user.teacherInfo?.isApproved ?? false;
      if (isApproved) {
        return {
          text: 'Giáo viên',
          color: 'bg-blue-100 text-blue-800 border-blue-200',
          icon: '👨‍🏫',
        };
      } else {
        return {
          text: 'Giáo viên (Chờ duyệt)',
          color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
          icon: '⏳',
        };
      }
    }
    
    if (isStudent) {
      return {
        text: 'Học sinh',
        color: 'bg-green-100 text-green-800 border-green-200',
        icon: '🎓',
      };
    }
    
    return {
      text: 'Người dùng',
      color: 'bg-gray-100 text-gray-800 border-gray-200',
      icon: '👤',
    };
  };

  const roleInfo = getRoleInfo();

  return (
    <div className="flex items-center space-x-1">
      <div className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium border ${roleInfo.color} ${className}`}>
        <span>{roleInfo.icon}</span>
        <span>{roleInfo.text}</span>
      </div>
      
      {isPro && (
        <div className="inline-flex items-center bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-2 py-0.5 rounded-md text-[10px] font-black uppercase tracking-wider shadow-sm border border-yellow-300 animate-pulse">
          <Star size={10} className="fill-white mr-1" />
          PRO
        </div>
      )}
    </div>
  );
};

export default UserRoleBadge;
